<template>

	<div class="content">
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-medium-size-10 md-size-10"></div>
			<div class="md-layout-item md-small-size-100 md-medium-size-80 md-size-80">
				<md-card>
					<md-card-header data-background-color="purple">
						<h4 class="title">ព័ត៌មានអំពីការរំលោះ</h4>
					</md-card-header>
					<md-card-content>
						<div class="md-layout">
							<div class="md-layout-item md-small-size-100 md-size-50">
								<md-table>
									<md-table-row>
										<md-table-cell style="width: 40%;">លេខកូដ</md-table-cell>
										<md-table-cell style="width: 5px">:</md-table-cell>
										<md-table-cell><b>
											<span v-if="String(loan.hash).length > 0">{{loan.hash}}</span>
											<span v-else>N/A</span></b>
										</md-table-cell>
									</md-table-row>
									<md-table-row>
										<md-table-cell>លេខឡូតិ៍</md-table-cell>
										<md-table-cell>:</md-table-cell>
										<md-table-cell>
											<b><span v-if="String(loan.lot).length > 0">{{loan.lot}}</span>
												<span v-else>N/A</span></b>
										</md-table-cell>
									</md-table-row>
									<md-table-row>
										<md-table-cell>ចំនួនរំលោះ</md-table-cell>
										<md-table-cell>:</md-table-cell>
										<md-table-cell>
											<b><span v-if="String(loan.amount).length > 0">{{config.moneylify(loan.amount)}}</span>
												<span v-else>N/A</span></b>
										</md-table-cell>
									</md-table-row>
								</md-table>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-50">
								<md-table>
									<md-table-row>
										<md-table-cell>លេខកូដអតិថិជន</md-table-cell>
										<md-table-cell>:</md-table-cell>
										<md-table-cell>
											<b><span v-if="String(loan.client_hash).length > 0">{{loan.client_hash}}</span>
												<span v-else>N/A</span></b>
										</md-table-cell>
									</md-table-row>
									<md-table-row>
										<md-table-cell>ឈ្មោះអតិថិជន</md-table-cell>
										<md-table-cell>:</md-table-cell>
										<md-table-cell>
											<b><span v-if="String(loan.client_name).length > 0">{{loan.client_name}}</span>
												<span v-else>N/A</span></b>
										</md-table-cell>
									</md-table-row>
									<md-table-row>
										<md-table-cell style="width: 40%;">លេខទូរស័ព្ទ</md-table-cell>
										<md-table-cell style="width: 5px;">:</md-table-cell>
										<md-table-cell>
											<b><span v-if="String(loan.client_phone).length > 0">{{loan.client_phone}}</span>
												<span v-else>N/A</span></b>
										</md-table-cell>
									</md-table-row>
								</md-table>
							</div>
						</div>
					</md-card-content>
				</md-card>
			</div>
			<div class="md-layout-item md-small-size-100 md-medium-size-10 md-size-10"></div>
		</div>

		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-medium-size-10 md-size-10"></div>
			<div class="md-layout-item md-small-size-100 md-medium-size-80 md-size-80">
				<md-card>
					<md-card-header data-background-color="purple">
						<h4 class="title">តាររាងបង់ប្រាក់</h4>
					</md-card-header>
					<md-card-content>
						<div class="md-layout">
							<div class="md-layout-item md-small-size-100 md-size-100">
								<md-table v-if="paymentList.length > 0">
									<md-table-row>
										<md-table-head>ខែ</md-table-head>
										<md-table-head>លេខកូដ</md-table-head>
										<md-table-head>ថ្ងៃបង់ប្រាក់</md-table-head>
										<md-table-head>ប្រាក់ដើម</md-table-head>
										<md-table-head>ការប្រាក់</md-table-head>
										<md-table-head>ប្រាក់ត្រូវបង់</md-table-head>
										<md-table-head>ប្រាក់ដើមនៅសល់</md-table-head>
										<md-table-head>ប្រាក់ពិន័យ</md-table-head>
										<md-table-head>ស្ថានភាព</md-table-head>
									</md-table-row>

									<md-table-row v-for="(payment, index) in paymentList">
										<md-table-cell>{{ payment.term_id }}</md-table-cell>
										<md-table-cell>{{ payment.hash }}</md-table-cell>
										<md-table-cell>{{ config.datelifyShort(payment.due_date) }}</md-table-cell>
										<md-table-cell>{{ config.moneylify(payment.principal) }}</md-table-cell>
										<md-table-cell>{{ config.moneylify(payment.interest) }}</md-table-cell>
										<md-table-cell><b>{{ config.moneylify(payment.interest + payment.principal)}}</b></md-table-cell>
										<md-table-cell>{{ config.moneylify(payment.balance) }}</md-table-cell>
										<md-table-cell>{{ config.moneylify(payment.fine) }}</md-table-cell>
										<md-table-cell>
											<span class="late" v-if="payment.status == 'pnd'">{{ config.getStatus(payment.status) }}</span>
											<span class="active" v-if="payment.status == 'pad'">{{ config.getStatus(payment.status) }}</span>
										</md-table-cell>
									</md-table-row>
								</md-table>
							</div>
						</div>
					</md-card-content>
				</md-card>
			</div>
			<div class="md-layout-item md-small-size-100 md-medium-size-10 md-size-10"></div>
		</div>
	</div>
</template>
<script>
	export default {
		created() {
			this.getLoan();
		},
		data() {
			return {
				loaded: false,
				paymentList: [],
				loan: {
					id: "",
					hash_id: "",
					interest_amount: "",
					loan_fee: "",
					total_payment: "",
					amount: "",
					term: "",
					initial_payment: "",
					monthly_payment: "",
					start_date: "",
					end_date: "",
					name: "",
					phone: "",
					next_payment: "",
					loan_balance: "",
					total_paid: "",
					note: "",
					status: ""
				},
			}
		},
		methods: {
			getLoan(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/public/tracking/" + this.$route.params.hash).then(data => {
					this.loan = data.body.data
					this.paymentList = data.body.data.paymentList;
					this.loaded = true;
				})
			}
		}
	}
</script>

<style>
	.paid-payment {
		display: flex;
		align-items: center;

	}
</style>



// WEBPACK FOOTER //
// src/pages/Loans.vue